import { RouteRecordRaw } from 'vue-router';
// demo页面
const Demo = () => import('@/view/demo/index.vue');
// 主页面
const MainPage = () => import('@/view/main/index.vue');
// chat页面
const MainChatPage = () => import('@/view/main/section/chat/index.vue');
// 发现页
const MainDiscover = () => import('@/view/main/section/discover/index.vue');
// 发现页
const MainBlank = () => import('@/view/main/section/blank/index.vue');
// 登录页面相关
const LoginPage = () => import('@/view/login/index.vue');
const AccountPage = () => import('@/view/login/section/account-page/index.vue');
const InvitePage = () => import('@/view/login/section/invite-code-page/index.vue');
const InfoPage = () => import('@/view/login/section/info-page/index.vue');
// 合同页面
const Contracts = () => import('@/view/contracts/index.vue');
const UserProto = () => import('@/view/contracts/user-proto/index.vue');
const ProtectInstructions = () => import('@/view/contracts/protect-instructions/index.vue');
const ThirdParty = () => import('@/view/contracts/third-party/index.vue');
const PrivacyPolicy = () => import('@/view/contracts/privacy-policy/index.vue');
// 被邀请页
const InvitedPage = () => import('@/view/invited/index.vue');
// 404
const NotFound = () => import('@/view/404/index.vue');

// 开发环境路由，线上不启用
const DEV_ROUTES: RouteRecordRaw[] = import.meta.env.VITE_BUILD_ENV === 'prod' ? []
  : [
    {
      path: '/demo',
      component: Demo,
    },
  ];
enum RouteName{
  account='account',
  info='info',
  inviteCode='inviteCode',
  mainChatPage='MainChatPage',
  mainBlankPage='mainBlankPage',
  MainDiscoverPage='MainDiscoverPage',
}
const ROUTES: RouteRecordRaw[] = [
  ...DEV_ROUTES,
  // 默认直接进chat页面，后面跟产品对接是否需要一个我的页面
  {
    path: '/',
    redirect: '/main/chat',
  },
  {
    path: '/main',
    component: MainPage,
    meta: {
      auth: true,
    },
    children: [
      {
        path: '',
        redirect: '/main/chat',
      },
      {
        path: 'chat/:gid(\\d+)?/:cid(\\d+)?',
        name: RouteName.mainChatPage,
        component: MainChatPage,
        meta: {
          auth: true,
        },
      },
      {
        path: 'discover',
        name: RouteName.MainDiscoverPage,
        component: MainDiscover,
        meta: {
          auth: true,
        },
      },
      {
        path: 'blank',
        name: RouteName.mainBlankPage,
        component: MainBlank,
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '/login',
    component: LoginPage,
    redirect: '/login/account',
    children: [
      {
        path: 'account',
        name: RouteName.account,
        component: AccountPage,
      },
      {
        path: 'invite',
        name: RouteName.inviteCode,
        component: InvitePage,
        meta: {
          auth: true,
        },
      },
      {
        path: 'info',
        name: RouteName.info,
        component: InfoPage,
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '/invited',
    component: InvitedPage,
  },
  {
    path: '/contracts',
    component: Contracts,
    children: [
      {
        path: 'user-proto',
        component: UserProto,
      },
      {
        path: 'protect-instructions',
        component: ProtectInstructions,
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicy,
      },
      {
        path: 'third-party',
        component: ThirdParty,
      },
    ],
  },
  {
    path: '/:w+',
    name: '404',
    component: NotFound,
  },
];

export { ROUTES, RouteName };
